import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'gene-avatar',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './avatar.component.html',
  styleUrl: './avatar.component.css'
})
export class AvatarComponent {
  @Input() label: string = '';
  @Input() size: 'sm' | 'md' | 'lg' = 'md';
  @Input() bgColor: string = '#54545C';

  get sizeClass() {
    return `rounded-${this.size}`;
  }

  get styles() {
    return {
      color: '#fff',
      backgroundColor: this.bgColor
    };
  }
}
